import { render, staticRenderFns } from "./InputRadios.vue?vue&type=template&id=097d0a6e&scoped=true&"
import script from "./InputRadios.vue?vue&type=script&lang=js&"
export * from "./InputRadios.vue?vue&type=script&lang=js&"
import style0 from "./InputRadios.vue?vue&type=style&index=0&id=097d0a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097d0a6e",
  null
  
)

export default component.exports